import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { toast } from 'sonner';

export const AddDaysDialog = ({ employee, type, open, onOpenChange, onAddDays }) => {
  const [days, setDays] = useState(0);
  const [reason, setReason] = useState('');
  
  const getTitle = () => {
    switch (type) {
      case 'progressive': return 'Agregar Días Progresivos';
      case 'administrative': return 'Agregar Días Administrativos';
      case 'used': return 'Registrar Días Ya Utilizados';
      default: return 'Agregar Días Adicionales';
    }
  };
  
  const getDescription = () => {
    switch (type) {
        case 'progressive': 
            return 'Establecer días progresivos del trabajador (reemplaza el valor actual). Los días progresivos NO se calculan retroactivamente, solo desde la fecha de asignación.';
        case 'administrative': 
            return 'Establecer días administrativos anuales del trabajador (reemplaza el valor actual)';
        case 'used': 
            return 'Registrar días de vacaciones ya tomados por el trabajador en otro sistema';
        default: 
            return 'Días adicionales especiales';
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!employee || days <= 0) {
      toast.error('Por favor ingrese un número válido de días');
      return;
    }
    
    console.log('AddDaysDialog: Enviando datos:', {
      employeeId: employee.id || employee._id,
      type,
      days,
      reason
    });
    
    try {
      await onAddDays?.(employee.id || employee._id, type, days, reason);
      toast.success(`${days} días ${type === 'progressive' ? 'progresivos' : type === 'used' ? 'utilizados' : 'adicionales'} agregados exitosamente`);
      onOpenChange(false);
      setDays(0);
      setReason('');
    } catch (error) {
      console.error('Error en AddDaysDialog:', error);
      toast.error('Error al agregar días: ' + (error.message || 'Error desconocido'));
    }
  };
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{getTitle()}</DialogTitle>
          <p className="text-sm text-muted-foreground">{getDescription()}</p>
        </DialogHeader>
        
        {employee && (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="bg-muted p-3 rounded-lg">
              <p className="font-medium">{employee.name}</p>
              <p className="text-sm text-muted-foreground">{employee.position}</p>
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="days">Cantidad de Días</Label>
              <Input
                id="days"
                type="number"
                min="0.5"
                step="0.5"
                value={days || ''}
                onChange={(e) => setDays(parseFloat(e.target.value) || 0)}
                placeholder="Ej: 5"
              />
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="reason">Motivo (Opcional)</Label>
              <Textarea
                id="reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Razón para la asignación de días adicionales..."
                rows={3}
              />
            </div>
            
            <div className="flex justify-end space-x-2 pt-4">
              <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
                Cancelar
              </Button>
              <Button type="submit" disabled={days <= 0}>
                Agregar Días
              </Button>
            </div>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
